const require_errors = require("./errors.cjs");
const require_isRepositoryName = require("./isRepositoryName.cjs");
//#region src/getGraphQLEndpoint.ts
/**
* Get a repository's Prismic GraphQL endpoint.
*
* @typeParam RepositoryName - Name of the Prismic repository.
* @param repositoryName - Name of the repository.
* @returns The repository's Prismic REST API V2 endpoint
*/
const getGraphQLEndpoint = (repositoryName) => {
	if (require_isRepositoryName.isRepositoryName(repositoryName)) return `https://${repositoryName}.cdn.prismic.io/graphql`;
	else throw new require_errors.PrismicError(`An invalid Prismic repository name was given: ${repositoryName}`, void 0, void 0);
};
//#endregion
exports.getGraphQLEndpoint = getGraphQLEndpoint;

//# sourceMappingURL=getGraphQLEndpoint.cjs.map